// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2jhBc","title":"BackImages_title__1NpBw","images":"BackImages_images__3_Egt"};